import { supabase } from '@/lib/supabase';

export type VisitorIpResult = { ip: string; blocked: boolean };

/**
 * Demande au Backend l'adresse IP réelle du visiteur et indique si elle est
 * bloquée par l'administrateur. En cas d'échec technique, on ne bloque pas
 * (fail-open) afin de ne jamais casser le parcours utilisateur.
 */
export async function checkVisitorIp(): Promise<VisitorIpResult> {
  try {
    const { data, error } = await supabase.functions.invoke('check-ip', { body: {} });
    if (error) return { ip: '', blocked: false };

    const payload = data as { ip?: string; blocked?: boolean } | null;
    return { ip: payload?.ip ?? '', blocked: Boolean(payload?.blocked) };
  } catch {
    return { ip: '', blocked: false };
  }
}